import { render, staticRenderFns } from "./release_index.vue?vue&type=template&id=20d005a9&scoped=true"
import script from "./release_index.vue?vue&type=script&lang=js"
export * from "./release_index.vue?vue&type=script&lang=js"
import style0 from "./release_index.vue?vue&type=style&index=0&id=20d005a9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d005a9",
  null
  
)

export default component.exports